import React, { useState } from "react";
import { FaBars, FaUserAlt} from "react-icons/fa";
import { MdDesignServices } from "react-icons/md";
import { RxResume } from "react-icons/rx";
import { FcContacts, FcHome } from "react-icons/fc";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { NavLink, Outlet } from "react-router-dom";
import "./sidebar.css";
const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => setIsOpen(!isOpen);

  const menuItem = [
    {
      path: "/",
      name: "Home",
      icon: <FcHome />,
    },
    {
      path: "/about",
      name: "About",
      icon: <FaUserAlt />,
    },
    {
      path: "/projects",
      name: "Projects",
      icon: <AiOutlineFundProjectionScreen />,
    },
    {
      path: "/services",
      name: "Services",
      icon: <MdDesignServices />,
    },

    {
      path: "/contact",
      name: "Contact",
      icon: <FcContacts />,
    },
    {
      path: "/blog",
      name: "Blog",
      icon: <RxResume />,
    },
  ];
  return (
    <div className="flex main-sidebar">
      <div className="flex flex-col  justify-center h-screen">
        <div
          onClick={toggle}
          className="toogle top-5 left-10 p-4 bg-slate-800 rounded-full fixed z-10 text-green-400 cursor-pointer text-3xl shadow-lg hover:ring-4 ring-green-400 ease-in duration-300 hover:text-white"
        >
          <FaBars />
        </div>
        <nav
          style={{
            opacity: isOpen ? "1" : "0",
          }}
          className="sidebar z-10"
        >
          <div style={{}} className="flex flex-col justify-center">
            {menuItem.map((item, index) => (
              <NavLink
                style={{ display: isOpen ? "block" : "none" }}
                to={item.path}
                key={index}
                className="link my-2"
                activeclassName="active"
              >
                <div style={{ opacity: isOpen ? "1" : "0" }}>
                  <div className="flex items-center">
                    <div className="icon transition mr-2">{item.icon}</div>
                    <div className="link_text">{item.name}</div>
                  </div>
                </div>
              </NavLink>
            ))}
          </div>
        </nav>
      </div>
      <div style={{ width: "100vw" }}>
        <Outlet />
      </div>
    </div>
  );
};

export default Sidebar;
